/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EmployeeInfo } from '../../models/employee-info';

export interface GetEmployees$Params {
}

export function getEmployees(http: HttpClient, rootUrl: string, params?: GetEmployees$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EmployeeInfo>>> {
  const rb = new RequestBuilder(rootUrl, getEmployees.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<EmployeeInfo>>;
    })
  );
}

getEmployees.PATH = '/api/v1/GetEmployees';
